import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { RootState } from '../store';
import { Image } from 'react-bootstrap';
import { useApi } from '../api/contexts/ApiContext';
import { Facility } from '../types/type';
import { getTimeLeft, formatNumber } from '../utils/utils';
import { INDUSTRY_ENUM, INDUSTRY_ENUM_CATEGORY, CATEGORY } from '../config/const';


interface PropsStructure {
    facility: Facility,
}

interface DataStructure {
    bids_count: number;
}

const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    const week = ['日', '月', '火', '水', '木', '金', '土'];
    return `${date.getFullYear()}年${(date.getMonth() + 1).toString().padStart(2, '0')}月${date.getDate().toString().padStart(2, '0')}日(${week[date.getDay()]})`;
};

const FacilityBlock: React.FC<PropsStructure> = ({ facility }) => {
    const [bidsCount, setBidsCount] = useState();
    const [option4, setOption4] = useState<boolean>(true);
    const [contractTypes, setContractTypes] = useState<string[]>();
    const [planType, setPlanType] = useState<boolean>(facility.plan_type);
    const { getModule } = useApi();
    const [favorite, setFavorite] = useState(facility.favorite);
    const [meteredRateVoltage, setMeteredRateVoltage] = useState(false);

    const [contractStartDate, setContractStartDate] = useState(formatDate(facility.contract_start_date))

    const { userInfo, userToken, error } = useSelector((state: RootState) => state.auth);

    // new Date().getTime() はミリ秒
    const nowInSeconds = Math.floor(new Date().getTime() / 1000);
    const tenDaysBeforeDue = nowInSeconds + (24 * 60 * 60 * 10);

    useEffect(() => {
        if (!facility) return;
        setMeteredRateVoltage(facility.category == 4); // 従量電灯

    }, [facility]);

    const handleFavorite = async () => {
        const generalApi = await getModule('GeneralApi');
        setFavorite(!favorite);

        if (userInfo) {
            await generalApi.toggleFavorite({ user_id: userInfo?.id, opportunity_id: facility.id });
        }
    }

    return (
        <>
            <div className="product-block bg-white">
                <div className="product-header">

                    <div className="row mx-0">
                        {facility.due > tenDaysBeforeDue && (
                            <Image src="/assets/images/mypage/new.svg" className="new-ribbon" />
                        )}
                        <div className={`col-10 offset-1 text-center px-0`}>

                            {getTimeLeft(facility.due).timeLeft > 0 && (
                                <div className="fw-300">

                                    <span className="text-red-theme text-md ml-lg-4 ml-3">
                                        {getTimeLeft(facility.due).timeLeft_str}
                                    </span>
                                    {getTimeLeft(facility.due).unit}
                                </div>)}

                        </div>
                        <div className={`col-1 px-0 text-right favorite star opportunity-id-${facility.id} 
                         ${favorite > 0 ? "active" : ''}`}
                            data-opportunity-id={`${facility.id}`} data-facility-id={`${facility.id}`}
                            onClick={handleFavorite}
                        ></div>
                    </div>
                </div>
                <Link to={`/project_detail?opportunity_id=${facility.id}&facility=${facility.facility_id}`} className="product-block-link">

                    <div className="product-body">
                        <div className="row mx-0 mb-3">
                            <div className="col-12 px-0">
                                <h2 className="product-title">
                                    <div className="row mx-0 mb-3">
                                        <div className="col-3 m-0 p-0">
                                            <span className="text-xxs">NO. 1{facility.id ? facility.id.toString().padStart(4, '0') : ''}</span>
                                        </div>
                                        <div className="col-9 m-0 p-0">
                                            {facility.name}
                                        </div>
                                    </div>
                                </h2>
                                <div className="product-sub-title">
                                    <div className="row mx-0 mb-2">
                                        <div className="col-3 m-0 p-0">
                                            <span className="btn-secondary text-white px-2 mr-2">{facility.industry && INDUSTRY_ENUM_CATEGORY[facility.industry] ? INDUSTRY_ENUM[INDUSTRY_ENUM_CATEGORY[facility.industry]] : INDUSTRY_ENUM['UNCLASSIFIED']}</span>
                                        </div>
                                        <div className="col-9 m-0 p-0">
                                            {facility.company_name} / {facility.address}
                                        </div>
                                    </div>
                                    <div className="row mx-0 mb-3">
                                        <div className="col-12 m-0 p-0">
                                            <span className="btn-secondary text-white px-2" style={{ backgroundColor: facility.category && CATEGORY[facility.category] ? CATEGORY[facility.category].color : '' }}>{facility.category ? CATEGORY[facility.category].name : ''}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0 mb-1 pt-2">
                            <div className="col-12 company-bar green"> 施設情報 </div>
                        </div>
                        <div className="product-details">
                            <div className="row mx-0 product-detail-row">
                                <div className="product-detail-row-title">送配電事業者</div>
                                <div className="">
                                    <div className="product-right-contents">{facility.supplier_name}</div>
                                </div>
                            </div>
                            <div className="row mx-0 product-detail-row">
                                <div className="product-detail-row-title">使用量電力</div>
                                <div className="">
                                    <span className="product-detail-key">{formatNumber(facility.usage_total)}</span> kWh
                                </div>
                            </div>
                            <div className="row mx-0 product-detail-row">
                                <div className="product-detail-row-title">
                                    <>契約電力</>

                                </div>
                                <div className="">
                                    <span className="product-detail-key">{facility.contract_usage}</span>
                                    {meteredRateVoltage ? <>kVA</> : <>kw</>}

                                </div>
                            </div>
                            <div className="row mx-0 product-detail-row last">
                                <div className="product-detail-row-title">負荷率</div>
                                <div className="">
                                    <span className="product-detail-key">{facility.annual_load_factor_p}</span> %
                                </div>
                            </div>
                        </div>
                        <div className="row mx-0 mb-1 pt-2">
                            <div className="col-12 company-note-bar"> 施設要望事項 </div>
                        </div>
                        <div className="product-details">
                            <div className="row mx-0 product-detail-row">
                                <div className="product-detail-row-title">希望プラン</div>
                                <div className="ml-auto ">
                                    {planType}
                                </div>
                            </div>
                            <div className="row mx-0 product-detail-row">
                                <div className="product-detail-row-title">再生可能エネルギー</div>
                                <span className="product-detail-key ml-auto mr-1">
                                    <Image src={`assets/images/other/icon-eco-${facility.option_4 ? "blue" : "ass"}.svg`} />
                                </span>
                                {facility.option_4 ? "希望する" : "希望しない"}
                            </div>
                            <div className="row mx-0 product-detail-row last">
                                <div className="product-detail-row-title">供給開始日</div>
                                <div className="">
                                    <span className="product-detail-key date">{contractStartDate}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </Link>
            </div>
        </>
    );
}

export default FacilityBlock;